import { render, staticRenderFns } from "./CandidateUploadSettings.vue?vue&type=template&id=4190ccdd"
import script from "./CandidateUploadSettings.vue?vue&type=script&lang=js"
export * from "./CandidateUploadSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4190ccdd')) {
      api.createRecord('4190ccdd', component.options)
    } else {
      api.reload('4190ccdd', component.options)
    }
    module.hot.accept("./CandidateUploadSettings.vue?vue&type=template&id=4190ccdd", function () {
      api.rerender('4190ccdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CandidateUploadSettings.vue"
export default component.exports